import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--poppins\",\"display\":\"swap\",\"preload\":true}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fraunces\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--fraunces\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"fraunces\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fira_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\"],\"variable\":\"--fira-mono\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"fira_mono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/AndroidBridge.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/NativeLinkInterceptor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/NativeRouteBridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppFooterContent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppHeaderContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppRecoverModalHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BasketSyncProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CampaignPopup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ClawDailyPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ClientRuntimeGuard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/GTMHealthMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GTMPageviewReporter.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/GTMReadySignals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/InstantRouteTransitionOverlay.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/MotherDayCountdownBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NativeAttributionInfoPopup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/PageBottomActions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ProductDealBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RootLayoutView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RootScrollFixer.tsx");
